module.exports = __webpack_public_path__ + "img/advan-write_2x.04874bba.png";